import React, { Component } from 'react';
import Loading from '../shared/Loading';
import gql from 'graphql-tag';
import { Query } from 'react-apollo';
import { Redirect } from 'react-router-dom';
import { useHistory } from 'react-router-dom';

const query = gql`
  query getGeoLocation {
    ipLocationInformation {
      countryCode
      stateCode
      cityCode
    }
  }
`;

const GeoRouter = () => {
  const history = useHistory();
  const pathName = history.location.pathname;
  const suffix = pathName.split('/')[1];
  const hasSuffix = suffix !== '';
  return (
    <Query query={query}>
      {({ loading, error, data, refetch }) => {
        console.log(data);

        if (loading)
          return (
            <div className="load-div">
              <Loading size="3x" />
            </div>
          );
        if (data.ipLocationInformation) {
          if (data.ipLocationInformation.countryCode === 'CA') {
            return <Redirect to={hasSuffix ? `tor/${suffix}` : 'tor'} />;
          } else if (data.ipLocationInformation.countryCode === 'US') {
            if (data.ipLocationInformation.stateCode === 'NY') {
              return <Redirect to={hasSuffix ? `nyc/${suffix}` : 'nyc'} />;
            } else {
              return <Redirect to={hasSuffix ? `sf/${suffix}` : 'sf'} />;
            }
          } else {
            return <Redirect to={hasSuffix ? `sf/${suffix}` : 'sf'} />;
          }
        }
      }}
    </Query>
  );
};

export default GeoRouter;



// WEBPACK FOOTER //
// ./src/components/GeoRouter/index.js